/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var TaskType;
(function (TaskType) {
    TaskType["General"] = "GENERAL";
})(TaskType || (TaskType = {}));
export function TaskTypeFromJSON(json) {
    return TaskTypeFromJSONTyped(json, false);
}
export function TaskTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function TaskTypeToJSON(value) {
    return value;
}
